
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 16.44a4.925 4.925 0 00-4.92 4.92.36.36 0 00.36.36h9.12a.36.36 0 00.36-.36A4.925 4.925 0 0012 16.44zM7.814 21a4.2 4.2 0 018.37 0h-8.37zM12 15.72a2.52 2.52 0 100-5.04 2.52 2.52 0 000 5.04zm0-4.32a1.8 1.8 0 110 3.601 1.8 1.8 0 010-3.601zM17.592 12.36a4.966 4.966 0 00-1.889.36.361.361 0 00.133.694.36.36 0 00.139-.027 4.252 4.252 0 011.617-.307c2.16 0 3.922 1.584 4.111 3.6h-5.707a.36.36 0 100 .72h6.084a.36.36 0 00.36-.36c0-2.58-2.174-4.68-4.848-4.68zM17.52 11.4a2.52 2.52 0 100-5.04 2.52 2.52 0 000 5.04zm0-4.32a1.8 1.8 0 110 3.6 1.8 1.8 0 010-3.6zM8.278 17.04a.36.36 0 00-.358-.36H2.297c.19-2.016 1.963-3.6 4.113-3.6.553-.002 1.101.104 1.613.312a.363.363 0 00.271-.672 4.976 4.976 0 00-1.884-.365c-2.673.005-4.85 2.105-4.85 4.685a.36.36 0 00.36.36h6a.36.36 0 00.358-.36zM6.48 11.4a2.52 2.52 0 100-5.04 2.52 2.52 0 000 5.04zm0-4.32a1.8 1.8 0 110 3.6 1.8 1.8 0 010-3.6zM10.68 5.702a.36.36 0 00-.72 0c0 .857.72 1.57 1.68 1.716v.502a.36.36 0 10.72 0v-.5c.96-.146 1.68-.858 1.68-1.715 0-.857-.72-1.57-1.68-1.716V1.95c.554.123.96.516.96.987a.36.36 0 10.72 0c0-.857-.72-1.57-1.68-1.716V.72a.36.36 0 00-.72 0v.5c-.96.146-1.68.858-1.68 1.715 0 .857.72 1.57 1.68 1.714v2.04c-.552-.123-.96-.516-.96-.987zm2.64 0c0 .48-.406.864-.96.987v-1.97c.554.122.96.518.96.983zm-2.64-2.767c0-.48.406-.864.96-.986v1.968c-.554-.12-.96-.514-.96-.982z","fill":"#fff"}})])
          )
        }
      }
    